<template>
  <div class="duration-block">
    <label class="sub-label">Course duration</label>
    <div class="duration-pills">
      <button
        v-for="d in durations"
        :key="d.code"
        type="button"
        class="duration-pill"
        :class="{ 'duration-pill--active': value === d.code }"
        @click="$emit('input', d.code)"
      >
        {{ d.label }}
      </button>
    </div>
  </div>
</template>

<script>
import { PA_COURSE_DURATIONS } from '@/constants/paStudentsRateCard';

export default {
  name: 'PaCourseDurationSelector',
  props: {
    value: { type: String, default: '1_YEAR' },
  },
  data() {
    return { durations: PA_COURSE_DURATIONS };
  },
};
</script>

<style scoped>
.sub-label {
  font-size: 0.78rem; font-weight: 600; color: #64748b;
  display: block; margin-bottom: 10px; text-transform: uppercase;
  letter-spacing: 0.04em;
}
.duration-pills {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
.duration-pill {
  padding: 11px 12px; border-radius: 10px;
  border: 1.5px solid #E2E8F0; background: white;
  font-size: 0.82rem; font-weight: 600; color: #475569;
  cursor: pointer; transition: all 0.15s; text-align: center;
}
.duration-pill:hover { border-color: #00AEEF; color: #1E4276; }
.duration-pill--active {
  border-color: #00AEEF; background: #EBF8FF; color: #0369A1;
  box-shadow: 0 0 0 1px #00AEEF;
}
@media (max-width: 600px) {
  .duration-pills { grid-template-columns: 1fr; }
}
</style>
